import React, { useEffect, useState } from 'react';
import { API_BASE_URL } from '../config';

const Reviews = () => {
  const [reviews, setReviews] = useState([]);
  const [form, setForm] = useState({ name: '', email: '', phone: '', description: '', rating: 0 });
  const isLoggedIn = !!localStorage.getItem('token');

  useEffect(() => {
    fetch(`${API_BASE_URL}/reviews`)
      .then(res => res.json())
      .then(data => {
        if (Array.isArray(data)) setReviews(data);
      })
      .catch(err => console.error('Error fetching reviews:', err));
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const res = await fetch(`${API_BASE_URL}/reviews`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(form),
    });
    const data = await res.json();
    if (res.ok) {
      alert('Review submitted successfully!');
      setForm({ name: '', email: '', phone: '', description: '', rating: 0 });
      setReviews(prev => [...prev, { ...form, id: data.id, status: 'pending' }]);
    } else {
      alert(data.error || 'Submission failed');
    }
  };

  const handleAction = async (id, status) => {
    const res = await fetch(`${API_BASE_URL}/reviews/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ status }),
    });
    const data = await res.json();
    if (res.ok) {
      setReviews(prev => prev.map(r => r.id === id ? { ...r, status: data.status } : r));
    }
  };

  return (
    <div className="reviews-page">
      <h2>Student Reviews</h2>

      {!isLoggedIn && (
        <>
                  {/* Approved Reviews List */}
                  <div className="approved-reviews">
                    {reviews.filter(r => r.status === 'approved').map(r => (
                      <div key={r.id} className="review-card">
                        <h4>{r.name}</h4>
                        <p>{r.description}</p>
                        <div className="stars">
                          {'★'.repeat(r.rating)}{'☆'.repeat(5 - r.rating)}
                        </div>
                      </div>
                    ))}
                  </div>
          {/* Review Form */}
          <form onSubmit={handleSubmit} className="review-form">
            <input type="text" placeholder="Name" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} required />
            <input type="email" placeholder="Email" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} required />
            <input type="text" placeholder="Phone" value={form.phone} onChange={e => setForm({ ...form, phone: e.target.value })} required />
            <textarea placeholder="Your Review" value={form.description} onChange={e => setForm({ ...form, description: e.target.value })} required />

            {/* ⭐ Star Rating */}
            <div className="rating">
              {[1,2,3,4,5].map(star => (
                <span
                  key={star}
                  className={form.rating >= star ? 'star selected' : 'star'}
                  onClick={() => setForm({ ...form, rating: star })}
                >
                  ★
                </span>
              ))}
            </div>

            <button type="submit">Submit Review</button>
          </form>


        </>
      )}

      {isLoggedIn && (

        <div className="table-responsive">
          <table className="reviews-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Description</th>
                <th>Rating</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {reviews.map(r => (
                <tr key={r.id}>
                  <td data-label="Name">{r.name}</td>
                  <td data-label="Email">{r.email}</td>
                  <td data-label="Phone">{r.phone}</td>
                  <td data-label="Description">{r.description}</td>
                  <td data-label="Rating">{'★'.repeat(r.rating)}{'☆'.repeat(5 - r.rating)}</td>
                  <td data-label="Status">{r.status}</td>
                  <td data-label="Actions">
                    {r.status === 'pending' && (
                      <>
                        <button className="approve-btn" onClick={() => handleAction(r.id, 'approved')}>Approve</button>
                        <button className="reject-btn" onClick={() => handleAction(r.id, 'rejected')}>Reject</button>

                      </>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

    </div>
  );
};

export default Reviews;